var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content" },
    [
      _c("div", { staticClass: "grid-view" }, [
        _c(
          "div",
          { staticClass: "main-content" },
          [
            _c(
              "search-item",
              {
                ref: "searchItem",
                attrs: {
                  "config-module": "940",
                  reset: true,
                  "custom-search-items": _vm.customSearchItems
                },
                on: {
                  "click-more": function(value) {
                    _vm.isAdvancedQuery = value
                  },
                  simSearchItemCallBack: _vm.toSimpleQuery,
                  advSearchItemCallBack: _vm.toAdvancedQuery
                }
              },
              [
                _c(
                  "div",
                  {
                    staticStyle: { display: "flex" },
                    attrs: { slot: "operations" },
                    slot: "operations"
                  },
                  [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.isAdvancedQuery,
                            expression: "!isAdvancedQuery"
                          }
                        ],
                        staticStyle: { "margin-right": "5px" }
                      },
                      [
                        _c(
                          "el-radio-group",
                          {
                            attrs: { no: "1" },
                            model: {
                              value: _vm.isJobNo,
                              callback: function($$v) {
                                _vm.isJobNo = $$v
                              },
                              expression: "isJobNo"
                            }
                          },
                          [
                            _c(
                              "el-radio",
                              {
                                staticStyle: { "margin-right": "5px" },
                                attrs: { label: 1 }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.BusinessNo")))]
                            ),
                            _c(
                              "el-radio",
                              {
                                staticStyle: { "margin-right": "5px" },
                                attrs: { label: 0 }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.BlNo")))]
                            )
                          ],
                          1
                        ),
                        _c("el-input", {
                          staticStyle: { width: "150px" },
                          attrs: {
                            placeholder:
                              _vm.$t("CargoMsg.Cargo_PlsInput") +
                              (_vm.isJobNo
                                ? _vm.$t("SeaExport.BusinessNo")
                                : _vm.$t("SeaExport.BlNo")),
                            no: "2"
                          },
                          model: {
                            value: _vm.jobNo,
                            callback: function($$v) {
                              _vm.jobNo = $$v
                            },
                            expression: "jobNo"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName: "v-permission",
                            value: ["button_AERouteCentral_BillingMAWB"],
                            expression: "['button_AERouteCentral_BillingMAWB']"
                          }
                        ],
                        attrs: {
                          type: "primary",
                          disabled: !_vm.btBillingMAWBEnabled,
                          no: "3"
                        },
                        on: {
                          click: function($event) {
                            return _vm.billingType("btBillingMAWB")
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("queryJob.prefabricatedMasterOrder"))
                        )
                      ]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName: "v-permission",
                            value: ["button_AERouteCentral_BillingMAWB"],
                            expression: "['button_AERouteCentral_BillingMAWB']"
                          }
                        ],
                        attrs: {
                          type: "primary",
                          disabled: !_vm.btBillingHAWBEnabled,
                          no: "4"
                        },
                        on: {
                          click: function($event) {
                            return _vm.billingType("btBillingHAWB")
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t("queryJob.prefabricationOrderSplitting")
                          )
                        )
                      ]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName: "v-permission",
                            value: ["button_AERouteCentral_BillingMAWB"],
                            expression: "['button_AERouteCentral_BillingMAWB']"
                          }
                        ],
                        attrs: {
                          type: "primary",
                          disabled: !_vm.btPrintMAWBEnabled,
                          no: "5"
                        },
                        on: {
                          click: function($event) {
                            return _vm.billingType("btPrintMAWB")
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("queryJob.printMasterOrder")))]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName: "v-permission",
                            value: ["button_AERouteCentral_BillingMAWB"],
                            expression: "['button_AERouteCentral_BillingMAWB']"
                          }
                        ],
                        attrs: {
                          type: "primary",
                          disabled: !_vm.btPrintHAWBEnabled,
                          no: "6"
                        },
                        on: {
                          click: function($event) {
                            return _vm.billingType("btPrintHAWB")
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("queryJob.printSplit")))]
                    )
                  ],
                  1
                )
              ]
            ),
            _c(
              "div",
              {
                staticClass: "section grid-wrapper",
                staticStyle: { "min-height": "350px" }
              },
              [
                _c("cargo-ag-grid", {
                  staticStyle: { width: "100%" },
                  attrs: {
                    "grid-options": _vm.gridOptions,
                    "column-defs": _vm.columnDefs,
                    "row-data": _vm.rowData,
                    "check-main-record": false,
                    "deselect-main-record": false,
                    "auto-fit-content": false
                  },
                  on: {
                    gridReady: function(params) {
                      _vm.gridApi = params.api
                    }
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "pagination-wrapper" },
              [
                _c("cargo-pagination", {
                  attrs: {
                    total: _vm.total,
                    page: _vm.pageNum,
                    limit: _vm.pageSize
                  },
                  on: {
                    "update:page": function($event) {
                      _vm.pageNum = $event
                    },
                    "update:limit": function($event) {
                      _vm.pageSize = $event
                    },
                    pagination: _vm.toPageQuery
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("billingDialog", {
        attrs: {
          visible: _vm.billingDialog.visible,
          job: _vm.billingDialog.job,
          "show-basic": true,
          "doc-type": _vm.billingDialog.docType
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.billingDialog, "visible", $event)
          },
          callback: _vm.billingDialog.callback
        }
      }),
      _c("cargo-template-selector-dialog", {
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          ctx: _vm.templateSelectorDialog.ctx,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data,
          "pre-print-callback": _vm.prePrintCallback,
          "printed-callback": _vm.printedCallback,
          "v2-check-callback": _vm.v2CheckCallback
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      }),
      _c("picture-view-window", {
        attrs: {
          visible: _vm.pictureView.visible,
          job: _vm.pictureView.job,
          model: _vm.pictureView.model,
          title: _vm.pictureView.title,
          "file-name": _vm.pictureView.fileName,
          type: _vm.pictureView.type
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.pictureView, "visible", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }